export class AdsOrganization {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    name!: string;
    display_name!: string;
    picture!: string;
    company_id!: string
    vat_id!: string
    street_address!: string
    office!: string
    postal_code!: string
    city!: string
    country!: string
    notes!: string
}
